export default {
  // Bottom Tab Bar
  home: 'Hem',
  jobs: 'Jobb',
  earnings: 'Intäkter',
  schedule: 'Schema',
  profile: 'Profil',
  
  // Common
  online: 'Online',
  offline: 'Offline',
  readyToReceiveOrders: 'Redo att ta emot order',
  notReceivingOrders: 'Tar inte emot order',
  receivingOrdersNow: 'Tar emot order nu',
  
  // Home Page
  goodMorning: 'God morgon',
  goodAfternoon: 'God eftermiddag',
  goodEvening: 'God kväll',
  youAreOnline: 'Du är online',
  youAreOffline: 'Du är offline',
  availableForDeliveries: 'Tillgänglig för leveranser',
  youWillReceiveNearbyOrders: 'Du kommer att få order i närheten',
  notReceivingOrdersNow: 'Tar inte emot order nu',
  goOnlineToStartEarning: 'Gå online för att börja tjäna',
  bike: 'Cykel',
  scooter: 'Skoter',
  car: 'Bil',
  onTheWay: 'PÅ VÄG',
  openJob: 'Öppna jobb',
  noActiveDeliveries: 'Inga aktiva leveranser',
  youreReadyToAcceptNewJobs: 'Du är redo att acceptera nya jobb',
  viewAvailableJobs: 'Visa tillgängliga jobb',
  findJobs: 'Hitta jobb',
  openMap: 'Öppna karta',
  mySchedule: 'Mitt schema',
  todaysSummary: 'Dagens sammanfattning',
  avgTime: 'Snitt tid',
  dailyGoal: 'Dagligt mål',
  highDemandExpected: 'Hög efterfrågan förväntas mellan 18:00–21:00',
  
  // Jobs Page
  availableJobs: 'Tillgängliga jobb',
  nearest: 'Närmast',
  highestPay: 'Högst betalning',
  earliest: 'Tidigast',
  availableDeliveries: 'tillgängliga leveranser',
  ready: 'Redo',
  preparing: 'Förbereder',
  new: 'Ny',
  pickupTime: 'Upphämtning',
  
  // Earnings Page
  todaysEarnings: 'Dagens intäkter',
  deliveries: 'leveranser',
  bonusToday: 'Bonus idag',
  thisWeek: 'Denna vecka',
  weekOverview: 'Veckoöversikt',
  recentDeliveries: 'Senaste leveranser',
  mon: 'Mån',
  tue: 'Tis',
  wed: 'Ons',
  thu: 'Tor',
  fri: 'Fre',
  sat: 'Lör',
  sun: 'Sön',
  
  // Schedule Page
  scheduleAndAvailability: 'Schema & Tillgänglighet',
  selectDate: 'Välj datum',
  availableShifts: 'Tillgängliga pass',
  yourShift: 'Ditt pass',
  slotsLeft: 'platser kvar',
  booked: 'Bokat',
  book: 'Boka',
  flexibleWorkHours: 'Flexibla arbetstider',
  flexibleWorkHoursDesc: 'Boka pass i förväg eller gå online när du vill. Du kan avboka upp till 2 timmar innan passet börjar.',
  
  // Notifications Page
  notifications: 'Meddelanden',
  all: 'Alla',
  orders: 'Order',
  messages: 'Meddelanden',
  promotions: 'Kampanjer',
  newOrderAvailable: 'Ny order tillgänglig',
  orderCancelled: 'Order avbruten',
  bonusEarned: 'Bonus intjänad!',
  messageFromCustomer: 'Meddelande från kund',
  weekendCampaign: 'Helgkampanj',
  deliveryCompleted: 'Leverans slutförd',
  minAgo: 'min sedan',
  hourAgo: 'timme sedan',
  hoursAgo: 'timmar sedan',
  
  // Profile Page
  settings: 'Inställningar',
  personalInfo: 'Personlig information',
  personalInfoDesc: 'Namn, e-post, telefon',
  vehicle: 'Fordon',
  vehicleDesc: 'Cykel',
  language: 'Språk',
  languageDesc: 'Svenska',
  support: 'Support',
  helpCenter: 'Hjälpcenter',
  helpCenterDesc: 'FAQ och guider',
  contactSupport: 'Kontakta support',
  contactSupportDesc: 'Chatta med oss',
  legal: 'Juridiskt',
  termsOfService: 'Användarvillkor',
  privacyPolicy: 'Integritetspolicy',
  logout: 'Logga ut',
  selectLanguage: 'Välj språk',
  swedish: 'Svenska',
  english: 'English',
  cancel: 'Avbryt',
  confirm: 'Bekräfta',
  
  // Active Delivery Page
  activeDelivery: 'Aktiv Leverans',
  deliveryProgress: 'Leveransförlopp',
  pickupLocation: 'Upphämtningsplats',
  deliveryLocation: 'Leveransplats',
  timeElapsed: 'Förfluten Tid',
  eta: 'Beräknad Tid',
  overtimeWarning: 'Ligger efter schemat',
  active: 'AKTIV',
  completed: 'KLAR',
  arrivedAtPickup: 'Anlänt till Upphämtning',
  confirmPickup: 'Bekräfta Upphämtning',
  arrivedAtCustomer: 'Anlänt till Kund',
  completeDelivery: 'Slutför Leverans',
  confirmPickupMessage: 'Verifiera orderartiklar innan du bekräftar upphämtning',
  completeDeliveryMessage: 'Lämna över beställningen till kunden',
  quickActions: 'Snabbåtgärder',
  call: 'Ring',
  navigate: 'Navigera',
  message: 'Meddelande',
  orderDetails: 'Orderdetaljer',
  viewFullDetails: 'Visa fullständiga detaljer',
  cancelDelivery: 'Avbryt Leverans',
  deliveryCompleted: 'Leverans Slutförd!',
  greatJob: 'Bra jobbat! Du tjänade',
  addedToEarnings: 'Tillagt till dina intäkter',
  backToHome: 'Tillbaka till Hem',
  findNextJob: 'Hitta Nästa Jobb',
};
